<template>
  <section>
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2">
      
      <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white">
        <SearchInput v-model="searchTerm" />
      </div>

      <DataTable :data="filteredData">
        <template #head>
          <th scope="col" class="px-6 py-3">ID</th>
          <th scope="col" class="px-6 py-3">Paciente</th>
          <th scope="col" class="px-6 py-3">Médico</th>
          <th scope="col" class="px-6 py-3">Atendimento</th>
          <th scope="col" class="px-6 py-3">Status</th>
          <th scope="col" class="px-6 py-3">#</th>
        </template>
      </DataTable>

    </div>
  </section>
</template>

<script setup>
import SearchInput from "@/components/Tables/SearchInput.vue";
import DataTable from "./../../components/_partials/DataTableExtin.vue";
import AsosService from "../../service/asos.service";
import { computed, onBeforeMount } from "vue";
import { dataAso } from "../../store";
import { ref } from "vue";
import { storeApp } from "@/store";

const store = dataAso;
const searchTerm = ref("");
const selectedFilter = ref("");

const dataTable = computed(() => {
  return store.getters?.getSchedules.map((row) => {
    // 

    return {
      ...row
    };
  });
})

// filtros
const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase();

  return dataTable.value.filter((row) => {
    if(selectedFilter.value === 'Todos') 
    selectedFilter.value = '';

    const matchesSearch = !searchTerm.value || 
      ['data', 'pacientes.nome', 'medicos.nome', 'medicos.especialidade'].some((key) => {
        const keys = key.split('.');
        let value = row;

        for (const k of keys) {
          value = value?.[k];
          if (!value) break;
        }

        return value?.toString().toLowerCase().includes(searchTermLower);
      });

    return matchesSearch;
  });
});

async function getSchedules() {
  await AsosService.getAllSchedules()
    .then((res) => {
      dataAso.dispatch("setAllSchedules", res.data);
    })
    .catch((err) => {
      console.log(err);
    });
}


onBeforeMount(async () => {
  storeApp.state.loading = true
  await getSchedules()  
  storeApp.state.loading = false
})

</script>
